export default {
  // CurricularMeshView
  all: 'todos',

  // CurricularMesh
  curricularMesh: 'Malla Curricular',
  modality: 'Modalidad',
  intermediateOutput: 'Salida intermedia',
  continuity: 'Continuidad',
  year: 'Año',
  level: 'Nivel',
  semester: 'Semestre',
  trimester: 'Trimestre',
  bimester: 'Bimestre',
  prerequisites: 'Prerrequisitos',
  indicatesIntermediateOutputSemester: '---------------- Indica semestre de la salida intermedia',
  inCaseMatterHasNoFormationLine: '* En caso de que la {matter} no tenga {formationLine}, se mostrará de color',
  number: 'N°',
  orderNumberOf: 'N° de orden de la',
  numberOf: 'N° de la',
  planLevel: 'Nivel del Plan',
  noAssociatedCompetence: 'Esta {matter} no tiene ninguna {competence} asociada.',
  matterHasModalities: 'Esta {matter} cuenta con {count} {modality}.',
  matterWithoutModality: '{matter} sin {modality}.',
  matterWithoutPrerequisites: 'Esta {matter} no cuenta con prerrequisitos.',
  noDataToShow: 'No hay {entity} para mostrar.',
  profileWithoutCompetences: 'El {profile} no cuenta con {competences}.',
  optionalField: 'Este campo es opcional.',
  total: 'Total',

  // EgressProfileCompetenceMentionForm
  type: 'Tipo',
  selectType: 'Seleccione un tipo',
  mention: 'Mención',
  diploma: 'Diploma',
  specialization: 'Especialización',
  certification: 'Certificación',
  other: 'Otro',
  specifyType: 'Especificar tipo',
  requiredWhenOther: 'Este campo es requerido cuando selecciona "Otro".',
}
